// src/pages/RegistrationSuccess.tsx
import RegistrationSuccess from "../../components/Hackathons/RegistrationSuccess";

export default function RegistrationSuccessPage() {
  return <RegistrationSuccess />;
}